var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "c-media-button", class: _vm.classes },
    [
      _c(
        "div",
        { staticClass: "c-media-button__ctn" },
        [
          _c(
            _vm.tag,
            _vm._b(
              {
                tag: "component",
                attrs: { "aria-label": "Play Video " + _vm.duration },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.callback.apply(null, arguments)
                  },
                },
              },
              "component",
              _vm.attrs,
              false
            ),
            [
              _c("uc-icon", {
                attrs: {
                  glyph: _vm.buttonIcon,
                  "class-name": "",
                  alt: "Play / Pause Video",
                },
              }),
              _vm._v(" "),
              _vm.duration && _vm.buttontype !== "podcast"
                ? _c("div", { staticClass: "c-media-button__duration" }, [
                    _vm._v("\n        " + _vm._s(_vm.duration) + "\n      "),
                  ])
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("uc-icon", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.showPodcastLogo,
            expression: "showPodcastLogo",
          },
        ],
        ref: "podcastLogo",
        attrs: { glyph: "podcast-uchicago", alt: "Podcast Logo" },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }